import { render, staticRenderFns } from "./LongSentence.vue?vue&type=template&id=24b59af7&"
import script from "./LongSentence.vue?vue&type=script&lang=js&"
export * from "./LongSentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports